import { MetricField } from "@/components/dashboard/metrics-games/common";
import { OpportunityScoreStartupSelector } from "@/components/dashboard/metrics-games/opportunity-score-startup-selector";

type Props = {
  previousScore: number;
  currentScore: number;
  deltaDays: number;
  onSetPreviousScore: (value: number) => void;
  onSetCurrentScore: (value: number) => void;
  onSetDeltaDays: (value: number) => void;
  searchInCard?: boolean;
};

export function GameScoreDelta({
  previousScore,
  currentScore,
  deltaDays,
  onSetPreviousScore,
  onSetCurrentScore,
  onSetDeltaDays,
  searchInCard = false
}: Props) {
  const delta = Number((currentScore - previousScore).toFixed(1));
  const deltaDirection = delta > 0 ? "up" : delta < 0 ? "down" : "flat";

  return (
    <article className="card metrics-game">
      <div className="metrics-game-head">
        <p className="section-label">Game 4</p>
        <h2 className="card-title">Score delta ({deltaDays}d)</h2>
      </div>
      <p className="card-desc">
        Set a previous score and current score to simulate 7d/30d direction and movement.
      </p>

      {searchInCard && (
        <div className="metrics-game-tenk-search">
          <OpportunityScoreStartupSelector
            slot="both"
            onLoadScoreInputs={() => {}}
            onLoadScore={onSetCurrentScore}
          />
        </div>
      )}

      <div className="metrics-inline-inputs">
        <label className="form-group">
          <span className="form-label">Previous score</span>
          <input
            type="number"
            className="form-input metrics-input"
            value={previousScore}
            onChange={(event) => onSetPreviousScore(Number(event.target.value))}
          />
        </label>
        <label className="form-group">
          <span className="form-label">Current score</span>
          <input
            type="number"
            className="form-input metrics-input"
            value={currentScore}
            onChange={(event) => onSetCurrentScore(Number(event.target.value))}
          />
        </label>
        <label className="form-group">
          <span className="form-label">Window days</span>
          <select
            className="filter-select"
            value={String(deltaDays)}
            onChange={(event) => onSetDeltaDays(Number(event.target.value))}
          >
            <option value="7">7</option>
            <option value="30">30</option>
            <option value="90">90</option>
          </select>
        </label>
      </div>

      <div className="score-breakdown-grid">
        <MetricField label="Delta" value={`${delta > 0 ? "+" : ""}${delta.toFixed(1)}`} />
        <MetricField label="Direction" value={deltaDirection} />
        <MetricField label="Formula" value={`delta = current - previous = ${currentScore} - ${previousScore}`} />
        <MetricField label="Status" value={delta > 0 ? "improving" : delta < 0 ? "cooling" : "flat"} />
      </div>
    </article>
  );
}
